module.exports = __webpack_public_path__ + "teqbahn-assets/media/footer1.c163b13c.png";